import T from 'prop-types';

export default {
  getModuleState: T.func.isRequired,
  currentProgress: T.number.isRequired,
  currentModule: T.number.isRequired,
  relapseAccess: T.bool.isRequired,
  dailyAccess: T.bool.isRequired,
  weeklyAccess: T.bool.isRequired,
  monthlyAccess: T.bool.isRequired,
  skillsAccess: T.bool.isRequired,
  role: T.string.isRequired,
  modules: T.arrayOf(
    T.shape({
      id: T.number.isRequired,
      title: T.string.isRequired,
      description: T.string.isRequired,
    })
  ),
};



// WEBPACK FOOTER //
// ./src/shapes/dashboard.js